import coreQuestionnaire from './coreQuestionnaire';
import dailySurvey from './dailySurvey';

const templates = {
  coreQuestionnaire,
  dailySurvey,
};

export default templates;
